import { Component,  OnInit, OnDestroy, Input } from '@angular/core';
import { BsModalRef, BsModalService} from 'ngx-bootstrap/modal';
import { LanguageTranslateService } from "src/app/_services/language-translate.service";
import { SubscriptionUtil } from 'src/app/_utilities/subscription';
import { JobOrdersService } from 'src/app/_services/job-orders.service';
import { SiteService } from 'src/app/_services/site.service';
import { UsersService } from 'src/app/_services/admin/users.service';
import { ErrorUtil } from 'src/app/_utilities/error';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { AuthenticationService } from 'src/app/auth/authentication.service';
@Component({
  selector: "app-create-block-task",
  standalone: false,
  templateUrl: "./create-block-task.component.html",
  styleUrl: "./create-block-task.component.scss",
})
export class CreateBlockTaskComponent
  extends SubscriptionUtil
  implements OnInit, OnDestroy
{
  translate: any;

  // Passed in when opening the modal (block/level/area context)
  @Input() blockPath: string = ""; // e.g. "Block A > L1 > Office"

  // Form fields
  jobScope: string = "";
  frequency: string = "daily"; // default selected pill

  month: any = null;
  day: string = "";

  jobTemplate: any = null;
  jobTemplateSuggestions: any[] = [];
  displayJobTemplateTable: boolean = false;

  // Dropdown option sets
  timeOptions: any[] = this.generateTimeOptions();
  endTimeOptions: any[] = this.generateTimeOptions();

  dailyFrequency: any[] = [
    { label: "Weekdays", value: "WEEKDAYS" },
    { label: "Weekend", value: "WEEKEND" },
    { label: "Both", value: "BOTH" },
  ];
  dayOfWeekOptions: any[] = [
    { label: "Monday", value: "MONDAY" },
    { label: "Tuesday", value: "TUESDAY" },
    { label: "Wednesday", value: "WEDNESDAY" },
    { label: "Thursday", value: "THURSDAY" },
    { label: "Friday", value: "FRIDAY" },
    { label: "Saturday", value: "SATURDAY" },
    { label: "Sunday", value: "SUNDAY" },
  ];

  dayOfMonthOptions: any[] = Array.from({ length: 31 }, (_, i) => ({
    label: String(i + 1),
    value: i + 1,
  }));

  monthOptions: any[] = [
    { label: "Jan", value: "JAN" },
    { label: "Feb", value: "FEB" },
    { label: "Mar", value: "MAR" },
    { label: "Apr", value: "APR" },
    { label: "May", value: "MAY" },
    { label: "Jun", value: "JUN" },
    { label: "Jul", value: "JUL" },
    { label: "Aug", value: "AUG" },
    { label: "Sep", value: "SEP" },
    { label: "Oct", value: "OCT" },
    { label: "Nov", value: "NOV" },
    { label: "Dec", value: "DEC" },
  ];

  requiredSkillOptions: any[] = [];
  requiredSkillTotalRecords: number = 0;
  requiredSkillPageSize: number = 10;
  requiredSkillLoading: boolean = false;
  private requiredSkillLoadedPages = new Set<number>();
  requiredSkillAssignments: any[] = [];
  requiredSkillAssignmentsSpliced: any[] = []; //first 10 records to show in UI
  showAllRequiredSkills: boolean = false;
  assignmentType: string = "ASSIGN_USER";
  taskForm!: FormGroup;
  userOptions: any = [];
  data: any;
  displayNewJO2: boolean;
  addonFeature: any;

  constructor(
    public modalRef: BsModalRef,
    private languageTranslateService: LanguageTranslateService,
    private jobOrdersService: JobOrdersService,
    private siteService: SiteService,
    private usersService: UsersService,
    private errorUtil: ErrorUtil,
    private modalServc: BsModalService,
    private auth: AuthenticationService,
  ) {
    super();
    this.taskForm = new FormGroup({
      taskName: new FormControl("", [
        Validators.required,
        Validators.maxLength(255),
      ]),
      jobTemplate: new FormControl("", [Validators.required]),
      skill: new FormControl(""),
      frequency: new FormControl(""),
      startTime: new FormControl("", [Validators.required]),
      endTime: new FormControl("", [Validators.required]),
      dailyFreq: new FormControl("WEEKDAYS", [Validators.required]),
      dayOfWeek: new FormControl("MONDAY"),
      dayOfMonth: new FormControl(1),
      dayOfQuarter: new FormControl(1),
      monthName: new FormControl("JAN"),
      dayMonth: new FormControl(1),
      autoGenType: new FormControl("none"),
      daysBeforeDueDate: new FormControl(1, [Validators.required]),
      onDayOfPreviousMonth: new FormControl(1),
      assignedUser: new FormControl("", [Validators.required]),//TO BE DELETED WHEN AUTO ASSIGN IS ENABLED
    });
  }

  ngOnInit(): void {
    this.getLanguageData();
    this.loadRequiredSkillsPage(1);
    this.loadActiveUsers();
    this.setDefaultTimes();
    this.updateEndTimeOptionsDisabledState();
    this.push(
      this.taskForm.controls["startTime"].valueChanges.subscribe(() => {
        this.updateEndTimeOptionsDisabledState();
      }),
    );

    this.addonFeature = this.auth.getAddonFeatureLists();
    var tenantPackagesJO2 = this.auth.getPackageCodeWithList("JO2");
    if (localStorage.getItem("packageCode") == "Old") {
      this.displayNewJO2 = this.addonFeature.addonJO2 == "JO2" ? true : false;
    } else {
      if (this.auth.getAddonPackageListsToHide("JO2")) {
        this.displayNewJO2 =
          tenantPackagesJO2.addonPackageList == "JO2" ||
          this.addonFeature.addonJO2 == "JO2"
            ? true
            : false;
      } else {
        this.displayNewJO2 = false;
      }
    }

    if (this.data.mode) {
      //if the modal is open in edit mode from contract view page => scheduled job list
      this.loadFormData();
    }
  }

  ngOnDestroy(): void {
    super.ngOnDestroy();
  }
  //Language
  getLanguageData() {
    this.push(
      this.languageTranslateService.wordSrc$.subscribe((data) => {
        if (Object.keys(data).length != 0) {
          this.translate = data;
        }
      }),
    );
  }

  push(obs: any) {
    super.push(obs);
  }

  selectFrequency(freq: string) {
    this.frequency = freq;
    // reset fields not relevant to the newly selected frequency
    this.taskForm.controls["dayOfWeek"].reset();
    this.taskForm.controls["dayOfMonth"].reset();
    this.taskForm.controls["dayOfQuarter"].reset();
    this.taskForm.controls["monthName"].reset();
    this.taskForm.controls["dayMonth"].reset();
    this.taskForm.controls["dailyFreq"].reset();

    this.taskForm.controls["dayOfWeek"].clearValidators();
    this.taskForm.controls["dayOfMonth"].clearValidators();
    this.taskForm.controls["dayOfQuarter"].clearValidators();
    this.taskForm.controls["monthName"].clearValidators();
    this.taskForm.controls["dayMonth"].clearValidators();
    this.taskForm.controls["dailyFreq"].clearValidators();

    this.taskForm.controls["dayOfWeek"].updateValueAndValidity();
    this.taskForm.controls["dayOfMonth"].updateValueAndValidity();
    this.taskForm.controls["dayOfQuarter"].updateValueAndValidity();
    this.taskForm.controls["monthName"].updateValueAndValidity();
    this.taskForm.controls["dayMonth"].updateValueAndValidity();
    this.taskForm.controls["dailyFreq"].updateValueAndValidity();

    this.month = null;
    this.day = "";

    if (this.frequency == "weekly") {
      this.taskForm.controls["dayOfWeek"].setValidators([Validators.required]);
      this.taskForm.controls["dayOfWeek"].setValue("MONDAY");
      this.taskForm.controls["dayOfWeek"].updateValueAndValidity();
    } else if (this.frequency == "monthly") {
      this.taskForm.controls["dayOfMonth"].setValue(1);
      this.taskForm.controls["dayOfMonth"].setValidators([Validators.required]);
      this.taskForm.controls["dayOfMonth"].updateValueAndValidity();
    } else if (this.frequency == "quarterly") {
      this.taskForm.controls["dayOfQuarter"].setValue(1);
      this.taskForm.controls["dayOfQuarter"].setValidators([
        Validators.required,
      ]);
      this.taskForm.controls["dayOfQuarter"].updateValueAndValidity();
    } else if (this.frequency == "yearly") {
      this.taskForm.controls["monthName"].setValidators([Validators.required]);
      this.taskForm.controls["monthName"].updateValueAndValidity();
      this.taskForm.controls["monthName"].setValue("JAN");
      this.taskForm.controls["dayMonth"].setValue(1);
      this.taskForm.controls["dayMonth"].setValidators([Validators.required]);
      this.taskForm.controls["dayMonth"].updateValueAndValidity();
    } else {
      //daily
      this.taskForm.controls["dailyFreq"].setValidators([Validators.required]);
      this.taskForm.controls["dailyFreq"].setValue("WEEKDAYS");
      this.taskForm.controls["dailyFreq"].updateValueAndValidity();
    }
  }

  private generateTimeOptions(): any[] {
    const options: any[] = [];
    for (let h = 0; h < 24; h++) {
      for (let m = 0; m < 60; m += 15) {
        const hh = h.toString().padStart(2, "0");
        const mm = m.toString().padStart(2, "0");
        options.push({ label: `${hh}:${mm}`, value: `${hh}:${mm}` });
      }
    }
    return options;
  }

  private setDefaultTimes(): void {
    const now = new Date();
    const oneHourLater = new Date(now.getTime() + 60 * 60 * 1000);
    this.taskForm.patchValue({
      startTime: this.roundToNearestTimeOption(now),
      endTime: this.roundToNearestTimeOption(oneHourLater),
    });

    if ( this.roundToNearestTimeOption(now) >= "23:00"){
      this.taskForm.patchValue({ endTime: this.addOneHour(this.taskForm.controls["startTime"].value) });
      this.taskForm.controls["endTime"].updateValueAndValidity();
    }

  }

  // Disables endTime options that are earlier than the selected startTime, so users can't pick an invalid range
  private updateEndTimeOptionsDisabledState(): void {
    const startTime = this.taskForm.controls["startTime"].value;
    if (startTime < '23:00'){ 
      this.endTimeOptions = this.timeOptions.map((option) => ({
        ...option,
        disabled: !!startTime && option.value <= startTime,
      }));

      const endTime = this.taskForm.controls["endTime"].value;
      if (startTime && endTime && endTime <= startTime) {
        this.taskForm.controls["endTime"].setValue(null);
      }
    }
    else{
      //remove all disabled states for endTime options
      this.endTimeOptions = this.timeOptions.map((option) => ({
        ...option,
        disabled: false,
      }));
      const endTime = this.taskForm.controls["endTime"].value;
      if (startTime && endTime && endTime <= startTime && this.roundToNearestTimeOption(new Date()) < "23:00") {
        //only reset endTime if the current time is before 23:00
        this.taskForm.controls["endTime"].setValue(null);
      }
    }
  }

  private addOneHour(time: string): string {
    const [hours, minutes] = time.split(":").map(Number);
    const newHours = (hours + 1) % 24;
    return `${newHours.toString().padStart(2, "0")}:${minutes.toString().padStart(2, "0")}`;
  }
  // timeOptions are generated in 15-minute increments, so round the given time to the nearest matching option
  private roundToNearestTimeOption(date: Date): string {
    let hours = date.getHours();
    let minutes = Math.round(date.getMinutes() / 15) * 15;
    if (minutes === 60) {
      minutes = 0;
      hours = (hours + 1) % 24;
    }
    const hh = hours.toString().padStart(2, "0");
    const mm = minutes.toString().padStart(2, "0");
    return `${hh}:${mm}`;
  }

  selectAssignment(type: string) {
    this.assignmentType = type;
    if (type !== "ASSIGN_USER") {
      this.taskForm.get("assignedUser")?.reset();
      this.taskForm.controls["assignedUser"].clearValidators();
      this.taskForm.controls["assignedUser"].updateValueAndValidity();
    } else {
      this.taskForm.controls["assignedUser"].setValidators([
        Validators.required,
      ]);
      this.taskForm.controls["assignedUser"].updateValueAndValidity();
    }
  }

  getJobTemplatesFirstWay(event: any) {
    const query = event.query;
    if (query != null && query.length > 0) {
      this.push(
        this.jobOrdersService
          .getAllJobOrderTemplates(
            query,
            null,
            null,
            null,
            null,
            null,
            null,
            "ACTIVE",
          )
          .subscribe({
            next: (res: any) => {
              this.jobTemplateSuggestions = res.body?.data ? res.body.data : [];
            },
            error: (err) => {
              this.errorUtil.setErrorMessage(err);
            },
          }),
      );
    }
  }

  gotSelectedJobTemplate(valueTemplate: any) {
    var val = valueTemplate.value ? valueTemplate.value : valueTemplate;
    this.jobTemplateSuggestions = [val];
    this.jobTemplate = val;
    this.taskForm.controls["jobTemplate"].setValue(val);
    this.taskForm.updateValueAndValidity();
    this.displayJobTemplateTable = false;
  }

  clearJobTemplate() {
    this.jobTemplate = null;
    this.taskForm.controls["jobTemplate"].reset();
    this.taskForm.updateValueAndValidity();
    this.jobTemplateSuggestions = [];
  }

  showJobTemplateTable() {
    this.displayJobTemplateTable = !this.displayJobTemplateTable;
  }

  closeJobTemplateView() {
    this.displayJobTemplateTable = false;
  }

  onAddRequiredSkill() {
    console.log('onAddRequiredSkill function entered..')
    let selectedSkill: any = this.taskForm.controls["skill"].value;
    if (!selectedSkill) return;
    const foundIdx = this.requiredSkillOptions.findIndex(
      (item: any) => item && item.id === selectedSkill,
    );
    if (foundIdx >= 0) {
      const found = this.requiredSkillOptions[foundIdx];
      this.requiredSkillAssignments.push({ ...found });
      this.requiredSkillOptions.splice(foundIdx, 1);
      this.requiredSkillOptions = [...this.requiredSkillOptions];
      //take first 10 records if show more toggle is NOT on (To prevent requiredSkillAssignmentsSpliced to get refreshed in UI)
      if (!this.showAllRequiredSkills) {
        this.requiredSkillAssignmentsSpliced =
          this.requiredSkillAssignments.slice(0, 10);
      }
    }
    this.taskForm.controls["skill"].reset();
    this.taskForm.controls["skill"].updateValueAndValidity();
  }

  removeRequiredSkill(skill: any, index: number) {
    this.requiredSkillAssignments.splice(index, 1);
    const idx: number = this.requiredSkillAssignmentsSpliced.findIndex(
      (s: any) => s.value === skill.value,
    );
    if (idx >= 0) {
      this.requiredSkillAssignmentsSpliced.splice(idx, 1);
    }
    const { color, background, ...option } = skill;
    this.requiredSkillOptions.push(option);
    this.requiredSkillOptions = [...this.requiredSkillOptions];
    // if (!this.requiredSkillAssignments.length) {
    //   this.taskForm.controls["skill"].setValidators([Validators.required]);
    //   this.taskForm.controls["skill"].updateValueAndValidity();
    // }
  }

  onShowMoreToggle() {
    this.showAllRequiredSkills = !this.showAllRequiredSkills;
    this.requiredSkillAssignmentsSpliced = this.showAllRequiredSkills
      ? this.requiredSkillAssignments
      : this.requiredSkillAssignments.slice(0, 10);
  }

  onRequiredSkillLazyLoad = (event: any) => {
    const last = event.last ?? event.first ?? 0;
    const page = Math.max(1, Math.ceil(last / this.requiredSkillPageSize));
    this.loadRequiredSkillsPage(page);
  };

  loadRequiredSkillsPage(page: number) {
    if (this.requiredSkillLoadedPages.has(page)) return;
    this.requiredSkillLoadedPages.add(page);

    this.requiredSkillLoading = true;
    this.push(
      this.siteService
        .getSkillLibrary(page, this.requiredSkillPageSize, "name", "asc")
        .subscribe({
          next: (res: any) => {
            const items = res?.data;
            const total = res?.total;

            if (this.requiredSkillOptions.length !== total) {
              this.requiredSkillOptions = Array.from({ length: total }, () => ({ label: "", id: null }));
            }
            this.requiredSkillTotalRecords = total;

            const startIndex = (page - 1) * this.requiredSkillPageSize;
            items.forEach((item: any, i: number) => {
              this.requiredSkillOptions[startIndex + i] = {...item}
            });

            this.requiredSkillOptions = [...this.requiredSkillOptions];
            this.requiredSkillLoading = false;
          },
          error: (err) => {
            this.requiredSkillLoading = false;
            this.requiredSkillLoadedPages.delete(page);
            this.errorUtil.setErrorMessage(err);
          },
        }),
    );
  }

  loadActiveUsers() {
    this.push(
      this.usersService.getActiveUsers().subscribe({
        next: (res: any) => {
          const users = res ?? [];
          this.userOptions = users;
        },
        error: (err) => {
          this.errorUtil.setErrorMessage(err);
        },
      }),
    );
  }

  onWorkScopeCreate() {
    if (this.taskForm.valid) {
      let skillArray: any = this.requiredSkillAssignments.map((skill) => ({
        id: skill.id,
      }));

      let autoGenType: any = this.taskForm.get("autoGenType")?.value;
      let autoGenerateWorkOrderStatus: any;
      if (autoGenType !== "DAYS_BEFORE" && autoGenType !== "none") {
        autoGenerateWorkOrderStatus =
          this.frequency == "daily" || this.frequency == "weekly"
            ? "ON_DAY_OF_PREVIOUS_MONTH_FOR_CURRENT_MONTH"
            : "ON_DAY_OF_PREVIOUS_MONTH";
      } else {
        autoGenerateWorkOrderStatus =
          autoGenType == "none" ? "DO_NOT_AUTO_GENERATE" : autoGenType;
      }
      //autoGenerateWorkOrderStatus = "DO_NOT_AUTO_GENERATE";
      if (!this.data.contractInfo) {
        let errMssg: string =
          "No contract related to the area is found. Please create/select a contract.";
        this.errorUtil.setErrorMessage(400, null, errMssg, "error", 2000);
        return;
      }

      let payload: any = {
        name: this.taskForm.get("taskName")?.value,
        siteBlockArea: { id: this.data.layerId },
        contract: { id: this.data.contractInfo.id },
        tmplJobOrder: { id: this.jobTemplate.id },
        frequency: this.frequency.toUpperCase(),
        dailyFrequency: this.taskForm.get("dailyFreq")?.value,
        startTime: this.taskForm.get("startTime")?.value + ":00",
        endTime: this.taskForm.get("endTime")?.value + ":00",
        dayOfWeek: this.taskForm.get("dayOfWeek")?.value,
        dayOfMonth:
          this.frequency == "monthly"
            ? this.taskForm.get("dayOfMonth")?.value
            : this.frequency == "quarterly"
              ? this.taskForm.get("dayOfQuarter")?.value
              : this.frequency == "yearly"
                ? this.taskForm.get("dayMonth")?.value
                : null,
        monthOfYear: this.taskForm.get("monthName")?.value,
        autoGenerateWorkOrderStatus: autoGenerateWorkOrderStatus,
        createDaysBeforeDueDate:
          autoGenerateWorkOrderStatus == "DAYS_BEFORE"
            ? this.taskForm.get("daysBeforeDueDate")?.value
            : this.taskForm.get("onDayOfPreviousMonth")?.value,
        //createDaysBeforeDueDate: 0,
        assignment: this.assignmentType,
        assignUser: { id: this.taskForm.get("assignedUser")?.value },
        skills: skillArray,
      };

      if (this.data.mode){
        //edit scheduled task
        payload["id"] = this.data.id;
        this.push(this.siteService.updateBlock(payload, this.data.layer).subscribe({
          next: (res: any) => {
            if (res.status == 200 || res.status == 201) {
              this.errorUtil.setErrorMessage(
                200,
                this.translate?.general.messages.savedSuccessfully,
                null,
                "success",
                2000,
              );

              let jsonObj: any = {
                layer: this.data.layer,
                reason: "newdata_added",
              };
              this.modalServc.setDismissReason(JSON.stringify(jsonObj));
              this.modalRef.hide();
            }
          },
          error: (err: any) => {
            var errorTitle = err.error.title;
            this.errorUtil.setErrorMessage(
              err.status,
              null,
              errorTitle,
              "error",
              2000,
            );
          },
        }));
        
      }
      else{
        this.push(this.siteService.createBlock(payload, this.data.layer).subscribe({
          next: (res: any) => {
            if (res.status == 200 || res.status == 201) {
              this.errorUtil.setErrorMessage(
                200,
                this.translate?.general.messages.savedSuccessfully,
                null,
                "success",
                2000,
              );

              let jsonObj: any = {
                layer: this.data.layer,
                reason: "newdata_added",
              };
              this.modalServc.setDismissReason(JSON.stringify(jsonObj));
              this.modalRef.hide();
            }
          },
          error: (err: any) => {
            var errorTitle = err.error.title;
            this.errorUtil.setErrorMessage(
              err.status,
              null,
              errorTitle,
              "error",
              2000,
            );
          },
        }));
      }
    } else {
      this.taskForm.markAllAsTouched();
    }
  }

  onAutoGenerateOptionsChange(event: any) {
    let selectedVal: any = this.taskForm.get("autoGenType")?.value;
    if (selectedVal == "DAYS_BEFORE") {
      this.taskForm.controls["daysBeforeDueDate"].setValidators([
        Validators.required,
      ]);
      this.taskForm.controls["onDayOfPreviousMonth"].clearValidators();

      this.taskForm.controls["daysBeforeDueDate"].updateValueAndValidity();
      this.taskForm.controls["onDayOfPreviousMonth"].updateValueAndValidity();
    } else if (selectedVal == "onDayOfPreviousMonth") {
      this.taskForm.controls["onDayOfPreviousMonth"].setValidators([
        Validators.required,
      ]);
      this.taskForm.controls["daysBeforeDueDate"].clearValidators();

      this.taskForm.controls["daysBeforeDueDate"].updateValueAndValidity();
      this.taskForm.controls["onDayOfPreviousMonth"].updateValueAndValidity();
    } else {
      this.taskForm.controls["daysBeforeDueDate"].clearValidators();
      this.taskForm.controls["onDayOfPreviousMonth"].clearValidators();
      this.taskForm.controls["daysBeforeDueDate"].updateValueAndValidity();
      this.taskForm.controls["onDayOfPreviousMonth"].updateValueAndValidity();
    }
  }

  loadFormData(){
    this.push(this.siteService.getBlockById('task', this.data.id).subscribe({
      next: (res: any) =>{
        console.log(res, "response from GET task by id api");
        if (res.status == 200){
          let workScope: any = res.body;
          this.jobTemplate = workScope.tmplJobOrder;

          workScope.skills.map ((s: any) =>{
            let selectedSkill: any = s.id;
            const foundIdx = this.requiredSkillOptions.findIndex(
              (item: any) => item && item.id === selectedSkill,
            );
            if (foundIdx >= 0) {
              const found = this.requiredSkillOptions[foundIdx];
              this.requiredSkillAssignments.push({ ...found });
              this.requiredSkillOptions.splice(foundIdx, 1);
              this.requiredSkillOptions = [...this.requiredSkillOptions];
              //take first 10 records if show more toggle is NOT on (To prevent requiredSkillAssignmentsSpliced to get refreshed in UI)
              if (!this.showAllRequiredSkills) {
                this.requiredSkillAssignmentsSpliced = this.requiredSkillAssignments.slice(0, 10);
              }
            }
          })
          if (this.requiredSkillAssignmentsSpliced.length){
            //if the array has at least one item, remove the validators
            this.taskForm.controls["skill"].reset();
            this.taskForm.controls["skill"].updateValueAndValidity();
          }

          this.frequency = workScope.frequency.toLowerCase();
          this.selectFrequency(this.frequency)
          this.selectAssignment(workScope.assignment);

          let autoGenTypeFormVal: any;
          let autoGenType: any = workScope.autoGenerateWorkOrderStatus;

          if (autoGenType == "DAYS_BEFORE"){
            autoGenTypeFormVal = "DAYS_BEFORE";
            this.taskForm.controls["daysBeforeDueDate"].setValidators([
              Validators.required,
            ]);
            this.taskForm.controls["onDayOfPreviousMonth"].clearValidators();

            this.taskForm.controls["daysBeforeDueDate"].updateValueAndValidity();
            this.taskForm.controls["onDayOfPreviousMonth"].updateValueAndValidity();
          }
          else if (autoGenType == "ON_DAY_OF_PREVIOUS_MONTH_FOR_CURRENT_MONTH" || autoGenType == "ON_DAY_OF_PREVIOUS_MONTH") {
            autoGenTypeFormVal = "onDayOfPreviousMonth";
            this.taskForm.controls["onDayOfPreviousMonth"].setValidators([
              Validators.required,
            ]);
            this.taskForm.controls["daysBeforeDueDate"].clearValidators();

            this.taskForm.controls["daysBeforeDueDate"].updateValueAndValidity();
            this.taskForm.controls["onDayOfPreviousMonth"].updateValueAndValidity();
          }
          else{
            //DO_NOT_AUTO_GENERATE option
            autoGenTypeFormVal = "none";
            this.taskForm.controls["daysBeforeDueDate"].clearValidators();
            this.taskForm.controls["onDayOfPreviousMonth"].clearValidators();
            this.taskForm.controls["daysBeforeDueDate"].updateValueAndValidity();
            this.taskForm.controls["onDayOfPreviousMonth"].updateValueAndValidity();
          }

          this.taskForm.patchValue({
            taskName: workScope.name,
            jobTemplate: workScope.tmplJobOrder,
            dailyFreq: workScope.dailyFrequency,
            dayOfWeek: workScope.dayOfWeek,
            dayOfMonth: workScope.dayOfMonth,
            dayOfQuarter: workScope.dayOfMonth,
            monthName: workScope.monthOfYear,
            dayMonth: workScope.dayOfMonth,
            autoGenType: autoGenTypeFormVal,
            daysBeforeDueDate: autoGenType == "DAYS_BEFORE" ? workScope.createDaysBeforeDueDate : null,
            onDayOfPreviousMonth: autoGenType !== "DAYS_BEFORE" ? workScope.createDaysBeforeDueDate : null,
            assignedUser: workScope.assignUser?.id,
            startTime: workScope.startTime?.replace(/:00$/, ""),
            endTime: workScope.endTime?.replace(/:00$/, "")
          });
        }
      },
      error: (err: any) =>{
        let errorTitle: any = err.error.title;
        this.errorUtil.setErrorMessage(
          err.status,
          null,
          errorTitle,
          "error",
          2000,
        );
      }
    }));
  }

  createNewSkill(){
    // Implement the logic to create a new skill here
  }

}
